// The LinkedIn post template of the bonus (ai-docs features/37-linkedin-bonus.md), in the portal's eight languages;
// the modal preselects the portal language. Written as a person would tell it (Robert, 29.10.2026: not boring, no AI
// slop, show that Mo builds almost anything), gender-neutral in every language. The link is never in the post
// (LinkedIn shows posts with outside links less) but in the first comment.

export const LINKEDIN_TEMPLATES = {
  de: {
    post: `Unsere Website hat ein neues Teammitglied. Es arbeitet nachts und am Wochenende, und ich habe dafür keine einzige Zeile Code geschrieben.

Es ist ein KI-Agent von Ultimo Bots. Ich habe Mo, dem KI-Builder in Ultimo Bots, einfach gesagt, was er können soll. Mo hat ihn gebaut und mit mir getestet.

Seitdem:
→ beantwortet er Kundenfragen rund um die Uhr, aus unseren eigenen Inhalten
→ sammelt er Leads und schickt sie direkt an uns
→ übergibt er an jemanden aus dem Team, wenn es knifflig wird

Am meisten überrascht hat mich: So lässt sich fast alles bauen. Terminbuchung, Lead-Qualifizierung, Produktberatung, Anbindungen an die Tools, die man eh schon nutzt. Man sagt einfach, was man braucht.

Lust, es auszuprobieren? Der Link ist im ersten Kommentar 👇

#KI #Kundenservice #KIAgenten`,
    comment: (link) => `Hier kannst du deinen eigenen KI-Agenten kostenlos bauen: ${link}`,
  },
  en: {
    post: `Our website has a new team member. It works nights and weekends, and I didn't write a single line of code for it.

It's an AI agent from Ultimo Bots. I just told Mo, the AI builder inside Ultimo Bots, what it should do. Mo built it and tested it with me.

Since then, it:
→ answers customer questions around the clock, from our own content
→ captures leads and sends them straight to us
→ hands over to someone on our team when it gets tricky

The most surprising part: you can build almost anything this way. Appointment booking, lead qualification, product advice, connections to the tools you already use. You just say what you need.

Want to try it? The link is in the first comment 👇

#AI #CustomerService #AIAgents`,
    comment: (link) => `Build your own AI agent for free here: ${link}`,
  },
  fr: {
    post: `Notre site a une nouvelle recrue. Elle travaille la nuit et le week-end, et je n’ai pas écrit une seule ligne de code.

C’est un agent IA d’Ultimo Bots. J’ai simplement expliqué à Mo, l’assistant qui construit les agents dans Ultimo Bots, ce que l’agent devait faire. Mo l’a construit et l’a testé avec moi.

Depuis :
→ il répond aux questions des clients 24 h/24, à partir de nos propres contenus
→ il recueille les leads et nous les transmet directement
→ il passe la main à quelqu’un de l’équipe quand ça se complique

Le plus surprenant : on peut construire presque tout de cette façon. Prise de rendez-vous, qualification de leads, conseil produit, connexion aux outils qu’on utilise déjà. Il suffit de dire ce dont on a besoin.

Envie d’essayer ? Le lien est dans le premier commentaire 👇

#IA #ServiceClient #AgentsIA`,
    comment: (link) => `Créez votre propre agent IA gratuitement ici : ${link}`,
  },
  es: {
    post: `Nuestra web tiene un nuevo miembro en el equipo. Trabaja de noche y los fines de semana, y no he escrito ni una línea de código.

Es un agente de IA de Ultimo Bots. Solo le expliqué a Mo, el asistente que construye los agentes en Ultimo Bots, lo que tenía que hacer. Mo lo construyó y lo probó conmigo.

Desde entonces:
→ responde las preguntas de los clientes las 24 horas, a partir de nuestros propios contenidos
→ recoge leads y nos los envía directamente
→ pasa la conversación a alguien del equipo cuando se complica

Lo que más me sorprendió: así se puede construir casi cualquier cosa. Reserva de citas, cualificación de leads, asesoramiento de productos, conexión con las herramientas que ya usas. Solo tienes que decir lo que necesitas.

¿Quieres probarlo? El enlace está en el primer comentario 👇

#IA #AtenciónAlCliente #AgentesIA`,
    comment: (link) => `Crea tu propio agente de IA gratis aquí: ${link}`,
  },
  it: {
    post: `Il nostro sito ha un nuovo membro del team. Lavora di notte e nel fine settimana, e non ho scritto nemmeno una riga di codice.

È un agente IA di Ultimo Bots. Ho semplicemente spiegato a Mo, l’assistente che costruisce gli agenti in Ultimo Bots, cosa doveva fare. Mo l’ha costruito e l’ha testato con me.

Da allora:
→ risponde alle domande dei clienti 24 ore su 24, in base ai nostri contenuti
→ raccoglie i lead e ce li manda direttamente
→ passa la parola a qualcuno del team quando la cosa si complica

La cosa più sorprendente: così si può costruire quasi tutto. Prenotazione di appuntamenti, qualificazione dei lead, consulenza sui prodotti, collegamenti con gli strumenti che usi già. Basta dire di cosa hai bisogno.

Vuoi provarlo? Il link è nel primo commento 👇

#IA #AssistenzaClienti #AgentiIA`,
    comment: (link) => `Crea il tuo agente IA gratis qui: ${link}`,
  },
  pt: {
    post: `O nosso site tem um novo membro na equipa. Trabalha à noite e ao fim de semana, e não escrevi uma única linha de código.

É um agente de IA da Ultimo Bots. Limitei-me a explicar ao Mo, o assistente que constrói os agentes na Ultimo Bots, o que ele devia fazer. O Mo construiu-o e testou-o comigo.

Desde então:
→ responde às perguntas dos clientes 24 horas por dia, com base nos nossos próprios conteúdos
→ recolhe leads e envia-os diretamente para nós
→ passa a conversa a alguém da equipa quando a coisa se complica

O que mais me surpreendeu: assim dá para construir quase tudo. Marcação de reuniões, qualificação de leads, aconselhamento de produtos, ligação às ferramentas que já usa. Basta dizer do que precisa.

Quer experimentar? O link está no primeiro comentário 👇

#IA #ApoioAoCliente #AgentesDeIA`,
    comment: (link) => `Crie o seu próprio agente de IA gratuitamente aqui: ${link}`,
  },
  nl: {
    post: `Onze website heeft een nieuwe collega. Die werkt ’s nachts en in het weekend, en ik heb er geen regel code voor geschreven.

Het is een AI-agent van Ultimo Bots. Ik heb Mo, de AI-bouwer in Ultimo Bots, gewoon verteld wat hij moest doen. Mo heeft hem gebouwd en samen met mij getest.

Sindsdien:
→ beantwoordt hij klantvragen dag en nacht, op basis van onze eigen content
→ verzamelt hij leads en stuurt ze direct naar ons door
→ draagt hij het gesprek over aan iemand van het team als het lastig wordt

Wat me het meest verraste: zo kun je bijna alles bouwen. Afspraken inplannen, leads kwalificeren, productadvies, koppelingen met de tools die je al gebruikt. Je zegt gewoon wat je nodig hebt.

Zin om het te proberen? De link staat in de eerste reactie 👇

#AI #Klantenservice #AIAgents`,
    comment: (link) => `Bouw hier gratis je eigen AI-agent: ${link}`,
  },
  pl: {
    post: `Nasza strona ma nowego członka zespołu. Pracuje w nocy i w weekendy, a do tego nie trzeba było pisać ani jednej linijki kodu.

To agent AI od Ultimo Bots. Wystarczyło opisać Mo, kreatorowi agentów w Ultimo Bots, co ma robić. Mo go zbudował i przetestował razem ze mną.

Od tego czasu:
→ odpowiada na pytania klientów całą dobę, na podstawie naszych własnych treści
→ zbiera leady i przesyła je prosto do nas
→ przekazuje rozmowę komuś z zespołu, gdy robi się trudno

Najbardziej zaskoczyło mnie to, że w ten sposób można zbudować prawie wszystko. Rezerwację terminów, kwalifikację leadów, doradztwo produktowe, połączenia z narzędziami, których już używasz. Wystarczy powiedzieć, czego potrzebujesz.

Chcesz spróbować? Link jest w pierwszym komentarzu 👇

#AI #ObsługaKlienta #AgenciAI`,
    comment: (link) => `Zbuduj tutaj za darmo własnego agenta AI: ${link}`,
  },
};
